export const DEFAULT_PREFIX = {
  title: "Hi 👋, I'm",
  currentWork: '🔭 I’m currently working on',
  currentLearn: '🌱 I’m currently learning',
  collaborateOn: '👯 I’m looking to collaborate on',
  helpWith: '🤝 I’m looking for help with',
  ama: '💬 Ask me about',
  contact: '📫 How to reach me',
  resume: '📄 Know about my experiences',
  funFact: '⚡ Fun fact',
  portfolio: '👨‍💻 All of my projects are available at',
  blog: '📝 I regularly write articles on',
};

export const DEFAULT_DATA = {
  title: '',
  subtitle: 'A passionate frontend developer from India',
  currentWork: '',
  currentLearn: '',
  collaborateOn: '',
  helpWith: '',
  ama: '',
  contact: '',
  funFact: '',
  twitterBadge: false,
  visitorsBadge: false,
  badgeStyle: 'flat',
  badgeColor: '0e75b6',
  badgeLabel: 'Profile views',
  githubProfileTrophy: false,
  githubStats: false,
  githubStatsOptions: {
    theme: '',
    titleColor: '',
    textColor: '',
    bgColor: '',
    hideBorder: false,
    cacheSeconds: null,
    locale: 'en',
  },
  topLanguages: false,
  topLanguagesOptions: {
    theme: '',
    titleColor: '',
    textColor: '',
    bgColor: '',
    hideBorder: false,
    cacheSeconds: null,
    locale: 'en',
  },
  streakStats: false,
  streakStatsOptions: {
    theme: '',
  },
  devDynamicBlogs: false,
  mediumDynamicBlogs: false,
  rssDynamicBlogs: false,
};

export const DEFAULT_LINK = {
  currentWork: '',
  collaborateOn: '',
  helpWith: '',
  portfolio: '',
  blog: '',
  resume: '',
};

export const DEFAULT_SOCIAL = {
  github: '',
  dev: '',
  linkedin: '',
  codepen: '',
  stackoverflow: '',
  kaggle: '',
  codesandbox: '',
  fb: '',
  instagram: '',
  twitter: '',
  dribbble: '',
  behance: '',
  medium: '',
  youtube: '',
  codechef: '',
  hackerrank: '',
  codeforces: '',
  leetcode: '',
  topcoder: '',
  hackerearth: '',
  geeks_for_geeks: '',
  discord: '',
  rssurl: '',
};

export const DEFAULT_SUPPORT = {
  buyMeACoffee: '',
};
